import dayjs from 'dayjs';
import {
  DiscountFormData,
  DiscountInputData,
} from '@/features/dashboard/discounts/schemas/discountSchema.ts';
import { DiscountDetailDto } from '@/features/dashboard/discounts/types/DiscountDetailDto.ts';
import { CreateDiscountDto } from '@/features/dashboard/discounts/types/CreateDiscountDto.ts';
import { UpdateDiscountDto } from '@/features/dashboard/discounts/types/UpdateDiscountDto.ts';
import { DiscountType } from '@/features/dashboard/discounts/types/DiscountType.ts';

function dateToString(date: Date | null): string | null {
  return date ? dayjs(date).format('YYYY-MM-DD') : null;
}

function stringToDate(str: string | null): Date | null {
  // dayjs parsuje "YYYY-MM-DD" jako lokalną północ; new Date dałby północ UTC
  return str ? dayjs(str).toDate() : null;
}

export const discountMapper = {
  fromDtoToForm(dto: DiscountDetailDto): DiscountInputData {
    return {
      name: dto.name,
      type: dto.type,
      value: dto.value,
      currency: dto.currency,
      promoCode: dto.promoCode ?? '',
      validFrom: stringToDate(dto.validFrom),
      validTo: stringToDate(dto.validTo),
      minParticipants: dto.minParticipants,
      minTotalPrice: dto.minTotalPrice,
      maxUsages: dto.maxUsages,
      maxDiscountAmount: dto.maxDiscountAmount,
      combinable: dto.combinable,
      tourIds: dto.tourIds,
      active: dto.active,
    };
  },

  toCreateDto(form: DiscountFormData): CreateDiscountDto {
    return {
      type: form.type,
      tourIds: form.tourIds,
      name: form.name,
      value: form.value,
      currency: form.currency,
      promoCode: form.promoCode || null,
      validFrom: dateToString(form.validFrom),
      validTo: dateToString(form.validTo),
      minParticipants: form.minParticipants,
      minTotalPrice: form.minTotalPrice,
      maxUsages: form.maxUsages,
      maxDiscountAmount:
        form.type === DiscountType.PERCENTAGE ? form.maxDiscountAmount : null,
      combinable: form.combinable,
    };
  },

  toUpdateDto(form: DiscountFormData): UpdateDiscountDto {
    return {
      type: form.type,
      name: form.name,
      value: form.value,
      currency: form.currency,
      promoCode: form.promoCode || null,
      validFrom: dateToString(form.validFrom),
      validTo: dateToString(form.validTo),
      minParticipants: form.minParticipants,
      minTotalPrice: form.minTotalPrice,
      maxUsages: form.maxUsages,
      maxDiscountAmount:
        form.type === DiscountType.PERCENTAGE ? form.maxDiscountAmount : null,
      combinable: form.combinable,
      tourIds: form.tourIds,
      active: form.active,
    };
  },
};
